import * as R from 'ramda';
import BaseController from './ecat.base.controller';

const library = require('@safe-systems/ss-ui-components');

const { copy } = library;

export default function ECATController(
  $location,
  $q,
  $rootScope,
  $scope,
  $filter,

  alerts,
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  orgDataService,
  editAssessmentDialog,
  serviceIds,
  ecatSettingsDialog,
  ssDialogService,
  userService
) {
  BaseController.call(this, userService, loaderService);
  this.initPermissions().then(_activate);

  const vm = this;

  vm.serviceAcceptanceHeaderText = copy.global.serviceAcceptanceHeaderText('ECAT');
  vm.eulaText = null;
  vm.eulaAccepted = true;
  vm.templatesAreLoaded = false;
  vm.templates = null;
  vm.assessmentsAreLoaded = false;
  vm.assessments = null;
  vm.appIsLoaded = false;
  vm.groupId = 15;

  vm.initAreLoaded = false;

  vm.handleAddAssessment = _handleAddAssessment;
  vm.handleShowSettings = _handleShowSettings;

  $rootScope.showAddAssessmentDialog = _showAddAssessmentDialog;
  $rootScope.reloadData = _reloadData;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    _initEventListeners();
    _initPage().then(() => {
      vm.appIsLoaded = true;
      loaderService.showViewLoader = false;
    });
  }

  function _initEventListeners() {
    $scope.$on('refreshECATAssessments', _refreshAssessments);
  }

  function _refreshAssessments() {
    return ecatDataService.getAssessments().then((response) => {
      ecatSharedModelService.assessments = response.data.result;
      vm.assessments = ecatSharedModelService.assessments;

      vm.incompleteAssessments = []; // $filter('filter')(vm.assessments, { status: 'active' });
      vm.completedAssessments = []; // $filter('filter')(vm.assessments, { status: 'completed' });
      vm.unknownAssessments = [];

      R.forEach((assessment) => {
        if (assessment.status === 'active') {
          vm.incompleteAssessments.push(assessment);
        } else if (assessment.status === 'completed') {
          vm.completedAssessments.push(assessment);
        } else {
          vm.unknownAssessments.push(assessment);
        }
      },
      vm.assessments);

      $rootScope.incompleteAssessments = $filter('orderBy')(vm.incompleteAssessments, 'approvalDate', true);
      $rootScope.completedAssessments = $filter('orderBy')(vm.completedAssessments, 'approvalDate', true);
      $rootScope.unknownAssessments = $filter('orderBy')(vm.unknownAssessments, 'approvalDate', true);

      $rootScope.latestCompletedAssessment = $filter('orderBy')(vm.completedAssessments, 'approvalDate', true)[0];

      vm.hasIncompleteAssessments = (vm.incompleteAssessments.length > 0);
      vm.hasCompletedAssessments = (vm.completedAssessments.length > 0);

      vm.assessmentsAreLoaded = true;
      ecatSharedModelService.dfdGetAssessments.resolve();
    });
  }

  function _refreshTemplates() {
    return ecatDataService.getCustomerTemplates().then((response) => {
      vm.templates = response.data.result;
      ecatSharedModelService.templates = vm.templates;
      vm.templatesAreLoaded = true;
      ecatSharedModelService.dfdGetTemplates.resolve();
    });
  }

  function _refreshUser() {
    return orgDataService.getIsNavantaUser().then((response) => {
      vm.isNavantaUser = response.data.result;
      ecatSharedModelService.dfdGetUser.resolve();
    });
  }

  function _getInitData() {
    return ecatDataService.getCRIInitData().then((response) => {
      ecatSharedModelService.achievementLevels = response.data.achievementLevels;
      ecatSharedModelService.maturityLevels = response.data.maturityLevels;
      ecatSharedModelService.criTierLevels = response.data.criTierLevels;
      vm.initAreLoaded = true;
      ecatSharedModelService.dfdGetInit.resolve();
    });
  }

  function _reloadData() {
    vm.templatesAreLoaded = false;
    vm.templates = null;
    vm.assessmentsAreLoaded = false;
    vm.assessments = null;
    vm.appIsLoaded = false;
    vm.initAreLoaded = false;

    _activate();
  }

  function _initPage() {
    const promises = [
      _refreshTemplates(),
      _refreshAssessments(),
      _refreshUser(),
      _getInitData(),
    ];

    return $q.all(promises);
  }
  function _handleShowSettings($event) {
    loaderService.showViewLoader = true;
    return ecatDataService.getSettings().then((response) => {
      loaderService.showViewLoader = false;
      ssDialogService.dialogs.ecat.editSettingsDialog = ssDialogService.alert(
        ecatSettingsDialog.getOptions($event, {
          settings: response.data,
        })
      );
      return ssDialogService.show(ssDialogService.dialogs.ecat.editSettingsDialog);
    });
  }

  function _handleAddAssessment($event) {
    loaderService.showViewLoader = true;
    ecatDataService.checkAllowNewAssessment().then((response) => {
      loaderService.showViewLoader = false;
      if (response.data.result) {
        _showAddAssessmentDialog($event).then(() => {
        });
      } else {
        alerts.warning('Only one active Assessment is allowed.');
      }
    });
  }

  function _showAddAssessmentDialog($event) {    
    return ecatDataService.getCustomerTemplates().then((response) => {
      ssDialogService.dialogs.ecat.editAssessmentDialog = ssDialogService.alert(
        editAssessmentDialog.getOptions($event, {
          templates: response.data.result,
          assessment: {
            assessmentId: 0,
          },
        })
      );
      ssDialogService.show(ssDialogService.dialogs.ecat.editAssessmentDialog);
    });
  }
}

ECATController.$inject = [
  '$location',
  '$q',
  '$rootScope',
  '$scope',
  '$filter',

  'alerts',
  'ecatDataService',
  'ecatSharedModelService',
  'loaderService',
  'orgDataService',
  'editAssessmentDialog',
  'serviceIds',
  'ecatSettingsDialog',
  'ssDialogService',
  'userService'
];
